exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header, footer {\n  padding: 1em;\n  color: white;\n  /*background-color: #6DBD46;*/\n  background-color: #1B4F58;\n  clear: left;\n  text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/terms-condition/terms-condition.component.scss
// module id = ../../../../../src/app/terms-condition/terms-condition.component.scss
// module chunks = main